import {
    IQueryContext,
    IQueryContextDatasourceColumn,
} from 'src/app/services/query-context/models/IQueryContext';
import {
    ICompiledSQLTokens,
    IDatasourceSQLMap,
    mergeSqlTokensArray,
} from 'src/app/utils/datasource-sql-map/datasource';
import { multipleSelectComponentCompileSQLTokens } from 'src/app/utils/datasource-sql-map/utils';
import { GcpProjectId } from 'src/app/utils/gcp-project-id.model';
import { buildSplitGroupSQL, buildWhereSQL } from 'src/app/utils/query/sql';

// player-events-ext-master-funnel
export class BiDevMasterFunnelStepsSqlMap {
    public static sqlMap: IDatasourceSQLMap = {
        dataset: 'bi_dev',
        tableId: 'ubi-693_master_funnel_steps',
        columns: {
            PROJECT_ID: {
                columnId: 'PROJECT_ID',
                columnSQL: 'project_id',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'project_id',
                        state
                    );
                },
            },
            FUNNELS_MASTER_FUNNEL_STEP_ID: {
                columnId: 'FUNNELS_MASTER_FUNNEL_STEP_ID',
                columnSQL: 'master_funnel_step_id',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'master_funnel_step_id',
                        state
                    );
                },
            },
            // ATTRIBUTION_CAMPAIGN_ADGROUP: {
            //     columnId: 'ATTRIBUTION_CAMPAIGN_ADGROUP',
            //     columnSQL: 'player_dim.attribution.unified_adgroup',
            //     compileSQLTokens: (state) => {
            //         return multipleSelectComponentCompileSQLTokens(
            //             'player_dim.attribution.unified_adgroup',
            //             state
            //         );
            //     },
            // },
            // ATTRIBUTION_CAMPAIGN_NAME: {
            //     columnId: 'ATTRIBUTION_CAMPAIGN_NAME',
            //     columnSQL: 'player_dim.attribution.unified_campaign',
            //     compileSQLTokens: (state) => {
            //         return multipleSelectComponentCompileSQLTokens(
            //             'player_dim.attribution.unified_campaign',
            //             state
            //         );
            //     },
            // },
            // ATTRIBUTION_TRAFFIC_SOURCE: {
            //     columnId: 'ATTRIBUTION_TRAFFIC_SOURCE',
            //     columnSQL: 'player_dim.attribution.unified_traffic',
            //     compileSQLTokens: (state) => {
            //         return multipleSelectComponentCompileSQLTokens(
            //             'player_dim.attribution.unified_traffic',
            //             state
            //         );
            //     },
            // },
            // ATTRIBUTION_NETWORK_NAME: {
            //     columnId: 'ATTRIBUTION_NETWORK_NAME',
            //     columnSQL: 'player_dim.attribution.unified_network',
            //     compileSQLTokens: (state) => {
            //         return multipleSelectComponentCompileSQLTokens(
            //             'player_dim.attribution.unified_network',
            //             state
            //         );
            //     },
            // },
            // FIREBASE_APP_STORE: {
            //     columnId: 'FIREBASE_APP_STORE',
            //     columnSQL: 'player_dim.revenue_sessions.first_store',
            //     compileSQLTokens: (state) => {
            //         return multipleSelectComponentCompileSQLTokens(
            //             'player_dim.revenue_sessions.first_store',
            //             state
            //         );
            //     },
            // },
            // FIREBASE_COUNTRY_EUROPEAN_UNION: {
            //     columnId: 'FIREBASE_COUNTRY_EUROPEAN_UNION',
            //     columnSQL: 'player_dim.geo.first_geo.country_european_union',
            //     compileSQLTokens: (state) => {
            //         return multipleSelectComponentCompileSQLTokens(
            //             'player_dim.geo.first_geo.country_european_union',
            //             state
            //         );
            //     },
            // },
            // FIREBASE_COUNTRY_TIER: {
            //     columnId: 'FIREBASE_COUNTRY_TIER',
            //     columnSQL: 'player_dim.geo.first_geo.country_tier_label',
            //     compileSQLTokens: (state) => {
            //         return multipleSelectComponentCompileSQLTokens(
            //             'player_dim.geo.first_geo.country_tier_label',
            //             state
            //         );
            //     },
            // },
            // FIREBASE_COUNTRY: {
            //     columnId: 'FIREBASE_COUNTRY',
            //     columnSQL: 'player_dim.geo.first_geo.unified_country',
            //     compileSQLTokens: (state) => {
            //         return multipleSelectComponentCompileSQLTokens(
            //             'player_dim.geo.first_geo.unified_country',
            //             state
            //         );
            //     },
            // },
            // FIREBASE_FIRST_OPEN_DATE: {
            //     columnId: 'FIREBASE_FIRST_OPEN_DATE',
            //     columnSQL: 'first_session_date',
            //     compileSQLTokens: (state) => {
            //         return DatePickerSqlTokensCompiler.compileTokens(
            //             'first_session_date',
            //             state
            //         );
            //     },
            // },
            // ETL_PAYER: {
            //     columnId: 'ETL_PAYER',
            //     columnSQL: 'player_dim.revenue_sessions.payer_label',
            //     compileSQLTokens: (state) => {
            //         return multipleSelectComponentCompileSQLTokens(
            //             'player_dim.revenue_sessions.payer_label',
            //             state
            //         );
            //     },
            // },
            // ETL_REVENUE_BADGE: {
            //     columnId: 'ETL_REVENUE_BADGE',
            //     columnSQL: 'player_dim.revenue_sessions.revenue_badge',
            //     compileSQLTokens: (state) => {
            //         return multipleSelectComponentCompileSQLTokens(
            //             'player_dim.revenue_sessions.revenue_badge',
            //             state
            //         );
            //     },
            // },
            // FIREBASE_INSTALL_VERSION: {
            //     columnId: 'FIREBASE_INSTALL_VERSION',
            //     columnSQL: 'player_dim.revenue_sessions.install_version',
            //     compileSQLTokens: (state) => {
            //         return multipleSelectComponentCompileSQLTokens(
            //             'player_dim.revenue_sessions.install_version',
            //             state
            //         );
            //     },
            // },
            // ACTIVITY_DATE: {
            //     columnId: 'ACTIVITY_DATE',
            //     columnSQL: 'DATE(master_funnel_start_timestamp)',
            //     compileSQLTokens: (state) => {
            //         return DatePickerSqlTokensCompiler.compileTokens(
            //             'DATE(master_funnel_start_timestamp)',
            //             state
            //         );
            //     },
            // },
            // ACTIVITY_APP_VERSION: {
            //     columnId: 'ACTIVITY_APP_VERSION',
            //     columnSQL: 'app_version',
            //     compileSQLTokens: (state) => {
            //         return multipleSelectComponentCompileSQLTokens(
            //             'app_version',
            //             state
            //         );
            //     },
            // },
            // SEGMENT: {
            //     columnId: 'SEGMENT',
            //     columnSQL: 'segments',
            //     compileSQLTokens: segmentContainerIdCompileSQLTokens,
            // },
        },
    };

    public static compileSQLStatements(
        supportedDatasourceColumns: IQueryContextDatasourceColumn[],
        queryContextSettings: IQueryContext['settings'],
        options: { gcpProjectId: GcpProjectId },
        customCompiledSqlTokens?: Partial<ICompiledSQLTokens>
    ) {
        const dateTrunc = queryContextSettings.dateAggregation
            ? `DATE_TRUNC(date, ${queryContextSettings.dateAggregation})`
            : `date`;

        const sqlTokensArray: Partial<ICompiledSQLTokens>[] =
            supportedDatasourceColumns.map((dsCol) => {
                return this.sqlMap.columns[dsCol.id]!.compileSQLTokens!(
                    dsCol.state,
                    options
                );
            });
        // merge tokens into single deduplicated object of type ICompiledSQLTokens
        const sqlTokens: ICompiledSQLTokens =
            mergeSqlTokensArray(sqlTokensArray);

        const splitSelect: string = buildSplitGroupSQL(sqlTokens.split_group);
        const splitGroupBy = splitSelect ? 'split_group, ' : '';
        const where: string = buildWhereSQL([
            ...sqlTokens.where,
            ...(customCompiledSqlTokens?.where ?? []),
        ]);
        const join: string = sqlTokens.join.join('\n');

        const windowTotal = splitGroupBy ? 'PARTITION BY split_group' : '';
        const windowRunning = splitGroupBy
            ? 'PARTITION BY split_group ORDER BY day_no'
            : 'ORDER BY day_no';

        return {
            dateTrunc,
            splitSelect,
            splitGroupBy,
            where,
            windowTotal,
            windowRunning,
            join,
        };
    }
}
